import * as React from 'react';
import { RouteComponentProps, Link } from 'react-router-dom';
import { fetchApi } from '../../services/api';
import * as moment from 'moment';
import { StreetAddressViewModel } from '../StreetAddress';
import { GridCell, GridColumn as Column, Grid } from '@progress/kendo-react-grid';

type Props = RouteComponentProps<{
    accountId: string;
}>

type State = {
    accountId: number;
    receipts: Receipt[];
    isLoading: boolean;
}

interface  Receipt {
    FacilityName: string;
    FacilityAddress: StreetAddressViewModel;
    Amount: number;
    BillingName: string;
    BillingAddress: StreetAddressViewModel;
    TenantName: string;
    Children: string[];
}

class InvoiceNumberCell extends GridCell {
    render() {
        if (this.props.dataItem.TaxReceiptID) {
            return (
                <td>
                    <Link style={{ color: '#007bff' }} to={ `/receipt/${ this.props.dataItem.TaxReceiptID }` }>
                        {this.props.dataItem.TaxReceiptNumber}
                    </Link>
                </td>
            );
        } else {
            return (
                <td>
                    <Link style={{ color: '#007bff' }} to={ `/accounts/${ this.props.dataItem.AccountID }/receipts/${ moment.utc(this.props.dataItem.Date).format("YYYY") }` }>
                        {this.props.dataItem.TaxReceiptNumber}
                    </Link>
                </td>
            );
        }
    }
}

class DateCell extends GridCell {
    render() {
        if (!this.props.field) return null;

        return (
            <td>{moment.utc(this.props.dataItem[this.props.field]).format("YYYY")}</td>
        );
    }
}

export default class Receipts extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);

        this.state = {
            isLoading: true,
            receipts: [],
            accountId: 0,
        }
    }

    public componentWillMount() {
        // This method runs when the component is first added to the page
        let accountId = parseInt(this.props.match.params.accountId) || 0;
        this.getReceipts(accountId);
    }

    public componentWillReceiveProps(nextProps: Props) {
        // This method runs when incoming props (e.g., route params) change
        let accountId = parseInt(nextProps.match.params.accountId) || 0;

        if (this.state.receipts && this.state.accountId != accountId) {
            this.getReceipts(accountId);
        }
    }

    public render() {
        return <div>
            <br/>
            <Grid data={this.state.receipts} scrollable='none'>
                <Column field="InvoiceID" title="#" cell={InvoiceNumberCell} />
                <Column field="Date" title="Year" cell={DateCell} filter="date" />
                <Column field="Amount" filter="numeric" format="{0:c}" />
            </Grid>
        </div>
    }

    private getReceipts(accountId: number) {
        this.setState({ isLoading: true, accountId });
        fetchApi(`api/Account/TaxReceipts/${accountId}`)
            .then((receipts: Receipt[]) => {
                this.setState({ isLoading: false, receipts });
            });
    }
}
